import {Component, Vue, Watch} from 'vue-property-decorator';
import {AxiosPromise, CancelTokenSource} from 'axios';

@Component
export default class DialogMixin extends Vue {
  protected dialog = false;
  protected loading = false;
  protected cancelRequest: CancelTokenSource | null = null;
  protected options: any = null;
  protected data: any = null;
  protected itemName: any = null;
  protected isFromPort = false;
  protected btn1 = '';
  protected btn2 = '';

  open(data: any, options: any) {
    this.options = options;
    this.init(data);
    this.dialog = true;
  }

  async openAsync(request: AxiosPromise, cancelRequest: CancelTokenSource, options: any) {
    this.dialog = true;
    this.cancelRequest = cancelRequest;
    this.options = options;
    const timerId = setTimeout(() => {
      this.loading = true;
    }, 100);
    try {
      const {data} = await request;
      this.init(data);
    } finally {
      clearTimeout(timerId);
      this.loading = false;
    }
  }

  close() {
    this.dialog = false;
    if (this.loading && this.cancelRequest) {
      this.cancelRequest.cancel();
      this.cancelRequest = null;
    }
    this.options = null;
    setTimeout(() => {
      this.loading = false;
      this.clear();
    }, 175);
  }

  init(data: any) {
    this.data = data;
    this.itemName = data?.itemName;
    this.isFromPort = data?.isFromPort;
    this.btn1 = data?.btn1;
    this.btn2 = data?.btn2;
  }

  clear() {
    this.data = null;
  }

  @Watch('dialog')
  onValueChange(value: boolean) {
    if (value)
      this.$nextTick().then(() => {
        this.onClickOutside();
      });
  }

  onClickOutside() {
    const focusable = Array.from(document.querySelectorAll('.v-dialog__content'));
    const active = focusable.find(el => el.classList.contains('v-dialog__content--active'));
    active && (active as HTMLElement).focus();
  }
}
